import { LoginTypes } from './actionTypes';

export const loginUser = (user: any, history: any, networkId: any) => {
  console.log('loginUser', user);
  return {
    type: LoginTypes.LOGIN_USER,
    payload: { user, history, networkId },
  };
};

export const loginSuccess = (user: any) => {
  return {
    type: LoginTypes.LOGIN_SUCCESS,
    payload: user,
  };
};

export const loginInvalid = (user: any) => {
  return {
    type: LoginTypes.LOGIN_INVALID,
    payload: user,
  };
};

export const logoutUser = (history: any) => {
  return {
    type: LoginTypes.LOGOUT_USER,
    payload: { history },
  };
};

export const logoutUserSuccess = (response: any) => {
  return {
    type: LoginTypes.LOGOUT_USER_SUCCESS,
    payload: response,
  };
};

export const apiError = (error: any) => {
  return {
    type: LoginTypes.API_ERROR,
    payload: error,
  };
};

export const socialLogin = (data: any, history: any, type: any) => {
  return {
    type: LoginTypes.SOCIAL_LOGIN,
    payload: { data, history, type },
  };
};

export const resetPassword = (user: any) => {
  return {
    type: LoginTypes.RESET_PASSWORD,
    payload: { user },
  };
};

export const resetPasswordSuccees = (user: any) => {
  return {
    type: LoginTypes.RESSET_PASSWORD_SUCCESS,
    payload: user,
  };
};

export const resetPasswordInvalid = (user: any) => {
  return {
    type: LoginTypes.RESSET_PASSWORD_FAIL,
    payload: user,
  };
};

export const resetStatus = () => {
  return {
    type: LoginTypes.RESET_STATUS,
  };
};
